"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShopPageSubscriptionHeader = ShopPageSubscriptionHeader;
const site_1 = require("../../shared/contexts/site");
const react_i18next_1 = require("react-i18next");
const react_1 = __importDefault(require("react"));
const types_1 = require("../../shared/types");
const provider_1 = require("../provider");
function ShopPageSubscriptionHeader({ cartData }) {
    const { context } = (0, site_1.useSiteState)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const { hasSubscription } = (0, provider_1.useSubscriptionOverviewState)();
    let viewOrdersURL = context + '/subscriptions';
    if (!viewOrdersURL.startsWith('/')) {
        viewOrdersURL = '/' + viewOrdersURL;
    }
    let isInstantLrp = (cartData === null || cartData === void 0 ? void 0 : cartData.lrpSubType) === types_1.LrpSubType.INSTANT;
    return react_1.default.createElement("div", { className: "loyalties__orders-box-header" },
        react_1.default.createElement("div", { className: "loyalties__orders-box-title-icon" },
            react_1.default.createElement("span", { className: "icon--loyalty-order icon--brand icon--no-hover" }),
            react_1.default.createElement("span", { "data-fieldname": "shop_subscription_order_header", className: "loyalties__orders-box-title" }, isInstantLrp ? t("text.header.instantrewards.orders") : t("text.account.order.mySubscription"))),
        (!isInstantLrp && !hasSubscription) &&
            react_1.default.createElement("a", { href: viewOrdersURL, className: `loyalties__orders-box__view-all` },
                react_1.default.createElement("span", { className: "link-secondary", "data-fieldname": "shop_subscription_view_all_link_text" }, t("text.mmsubscription.settings.header.view.orders"))));
}
